import React from 'react'

import Buttons from 'components/Buttons'
import Link from 'components/Link'
import Meta from 'components/Meta'
import SignInForm from 'components/SignInForm'
import UnauthBox from 'components/UnauthBox'
import UnauthView from 'components/UnauthView'
import paths from 'constants/paths'

export default function SignIn(props) {
  const title = 'Sign in'

  const { state } = props.location

  return (
    <UnauthView className="SignIn">
      <Meta title={title} />
      <UnauthBox
        title={title}
        actions={
          <Buttons>
            <Link to={paths.SIGN_UP} icon="plus-circle" muted>Create account</Link>
            <Link to={paths.PASSWORD_RESET} icon="question" muted>Forgot password</Link>
          </Buttons>
       }>
        <p>
         to continue to AMAL in Heritage
        </p>
        <SignInForm onCompleteRedirectTo={(state && state.redirectedFrom) || null} />
      </UnauthBox>
    </UnauthView>
  )
}



// WEBPACK FOOTER //
// ./src/views/SignIn/SignIn.js